import React from 'react';
import { LastUpdatedText, LeaderboardTypeButton, LeaderboardTypes, Table, Wrapper } from './styles';
import Filters from './Filters';
import { IBlockRegion, IFortniteLeaderboardBlockData, LeaderboardType, getLastUpdatedDateString } from '../utils';
import { useAdminTranslation } from 'hooks/use-translation';
import LoggedUserPosition from './LoggedUserPosition';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import { FortniteLeaderboardProvider, useFortniteLeaderboardContext } from './Context/Context';

type LeaderboardProps = {
  defaultFilters: IFortniteLeaderboardBlockData['defaultFilters'];
  region: IBlockRegion;
};

const Leaderboard: React.FC = () => {
  const { onChangeLeaderboardType, isRanked, isPanel } = useFortniteLeaderboardContext();
  const { t } = useAdminTranslation();

  const handleChangeLeaderboardType = (leaderboardType: LeaderboardType) => () => {
    onChangeLeaderboardType(leaderboardType);
  };

  return (
    <Wrapper isPanel={isPanel}>
      <LeaderboardTypes isPanel={isPanel}>
        <LeaderboardTypeButton active={!isRanked} onClick={handleChangeLeaderboardType('general')}>{t('GENERAL')}</LeaderboardTypeButton>
        <LeaderboardTypeButton active={isRanked} onClick={handleChangeLeaderboardType('ranked')}>{t('RANKED')}</LeaderboardTypeButton>
      </LeaderboardTypes>
      <Filters />

      {/* TODO: Only show this when oauth by epic */}
      <LoggedUserPosition />

      <Table isRanked={isRanked} isPanel={isPanel}>
        <TableHeader />
        <TableBody />
      </Table>
      {/* TODO: Update this with integration */}
      <LastUpdatedText isPanel={isPanel}>{t('ADMIN_LABEL_LAST_UPDATED')}: {getLastUpdatedDateString(Date.now())}</LastUpdatedText>
    </Wrapper>
  );
};

export default ({ defaultFilters, region }: LeaderboardProps) => (
  <FortniteLeaderboardProvider defaultFilters={defaultFilters} region={region}>
    <Leaderboard />
  </FortniteLeaderboardProvider>
);
